import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const setupTelegramMenuButtonDataSchema = z.object({
  result: z.unknown().optional(),
  error: z.string().optional(),
});

export type ISetupTelegramMenuButtonData = z.infer<typeof setupTelegramMenuButtonDataSchema>;

export const setupTelegramMenuButtonResponseSchema = createApiResponseSchema(
  setupTelegramMenuButtonDataSchema,
) as z.ZodSchema<IAPI<ISetupTelegramMenuButtonData>>;

export type ISetupTelegramMenuButtonResponse = IAPI<ISetupTelegramMenuButtonData>;
